module.exports = __webpack_public_path__ + "static/img/news21-2.308ca8b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/newsMore/news21-2.jpg
// module id = ki1O
// module chunks = 0